import "core-js/modules/es6.regexp.replace";
import _get from "lodash/get";
// Dependencies
import React from 'react';
import PropTypes from 'prop-types'; // Utils

import classNames from 'classnames';
import numeral from 'numeral';
// Components
import HelpBubble from '@nerdwallet/react-help-bubble';
import { Text } from '@nerdwallet/react-typography';
import estimate from './estimate'; // Mixins

import isVisible from '../isVisible';

var isValid = function isValid(value) {
  return value !== null && typeof value !== 'undefined';
};

var ProductLabel = function ProductLabel(_ref) {
  var data = _ref.data,
      config = _ref.config,
      customComponents = _ref.customComponents;

  function resolveText() {
    var product = data;

    if (config && config.text) {
      var keys = config.data_keys || [];
      return keys.reduce(function (resolvedText, key, i) {
        return resolvedText.replace("%".concat(i), _get(product, key));
      }, config.text);
    }

    if (config.data_keys && config.data_keys.length) {
      return config.data_keys.map(function (dataKey) {
        return _get(product, dataKey);
      });
    }

    return undefined;
  }

  function renderValue() {
    return function (format, values, fallback) {
      var value = values;

      switch (format) {
        case 'currency':
          value = values[0];

          if (isValid(value)) {
            return [React.createElement("span", {
              key: "super"
            }, "$"), numeral(value || 0).format('0,0[.]00[0]')];
          }

          return fallback;

        case 'currency-estimate':
          value = values[0];

          if (isValid(value)) {
            return [React.createElement("span", {
              key: "super"
            }, "$"), estimate(value || 0, true)];
          }

          return fallback;

        case 'percentage':
          value = values[0];

          if (isValid(value)) {
            return [numeral(value || 0).format('0.00'), React.createElement("span", {
              key: "super"
            }, "%")];
          }

          return fallback;

        case 'percentage-range':
          if (isValid(values)) {
            return [values.map(function (percentage) {
              return numeral(percentage || 0).format('0.00');
            }).join('-'), React.createElement("span", {
              key: "super"
            }, "%")];
          }

          return fallback;

        default:
          return isValid(value) ? value : fallback;
      }
    }(config.format, resolveText(), _get(config, 'fallback'));
  }

  if (!isVisible(config)) {
    return null;
  }

  var topAnnotation;

  if (config && config.top_annotation) {
    topAnnotation = React.createElement(Text, {
      small: true
    }, config.top_annotation);
  }

  var annotation;

  if (config && config.annotation) {
    annotation = React.createElement(Text, {
      small: true
    }, config.annotation);
  }

  var helpBubble;

  if (config.help) {
    var customHelpRenderer = customComponents[config.help.component];

    var helpContent = customHelpRenderer && customHelpRenderer.call({
      props: {
        data: data,
        config: config,
        customComponents: customComponents
      }
    }) || _get(data, _get(config, 'help.data_keys.0'), config.help.text);

    helpBubble = helpContent ? React.createElement(HelpBubble, {
      popoverContent: helpContent
    }) : null;
  }

  if (!isValid(renderValue())) {
    return null;
  }

  return React.createElement("div", {
    className: classNames('product-label', config.className)
  }, topAnnotation, React.createElement(Text, {
    small: true,
    className: "product-table-cell-main-content"
  }, renderValue(), helpBubble), annotation);
};

ProductLabel.displayName = 'ProductLabel';
ProductLabel.defaultProps = {
  config: {},
  customComponents: {}
};
ProductLabel.propTypes = {
  data: PropTypes.object,
  config: PropTypes.shape({
    /** text to display  */
    text: PropTypes.string,

    /** paths for the data object; can either be interpolated into text or rendered on their own */
    data_keys: PropTypes.array,

    /** the format for the label: 'currency', 'percentage', and 'currency-estimate' are supported */
    format: PropTypes.string,

    /** a fallback value to render if the label text evaluates to null or undefined */
    fallback: PropTypes.string,

    /** annotation above the label */
    top_annotation: PropTypes.string,

    /** annotation beneath the label */
    annotation: PropTypes.string,

    /** controls whether or not the label should render */
    visible: PropTypes.string,

    /** help tooltip */
    help: PropTypes.shape({
      /** custom component to render the help tooltip */
      component: PropTypes.node,
      data_keys: PropTypes.array,
      text: PropTypes.string
    })
  }),
  customComponents: PropTypes.object
};
export default ProductLabel;